<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>{{ boxTitle }}</b>
						</h3>
					</div>
					<div class="box-body">
						<div class="row">
							<div class="col-md-12">
								<div class="form-group">
									<label>Nome </label>
									<input v-validate="'required'" name="nome" v-model="dados.nome" class="form-control" type="text">
									<span class="text-danger">{{ errors.first('nome') }}</span>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="form-group">
									<label>Descrição </label>
									<textarea v-validate="'required'" rows="8" name="descricao" v-model="dados.descricao" class="form-control" type="text"></textarea>
									<span class="text-danger">{{ errors.first('descricao') }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="box-footer">
						<div class="row">
							<div class="col-md-12">
								<button @click="salvar()" class="btn btn-primary pull-right" type="button"><i class="fa fa-save"></i> Salvar</button>
								<button class="btn btn-default pull-left" @click="$router.go(-1)"> <i class="fa fa-reply"></i> Voltar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from "axios"; // Cliente para requisição http

	export default {
		inject: ["$validator"],
		data: () => ({
			dados: {
				nome: "",
				descricao: "",
			},
			preparoId: "",
			boxTitle: "Novo Preparo"
		}),
		mounted() {
			this.preparoId = this.$route.params.preparoId;
			if (this.preparoId) {
				this.boxTitle = "Editar Preparo";
				this.getPreparo(this.preparoId);
			}
		},
		methods: {
			getPreparo(preparoId) {
				axios
					.get(
						`${this.$store.state.serverURI}/api/cadastros/preparos/getById/${this.preparoId}`,
						this.$store.getters.getHeaderAuth
					)
					.then(response => {
						this.dados = response.data;
					})
					.catch(error => {
						console.log(error);
					});
			},
			salvar() {
				this.$validator.validate().then(result => {
					if (result) {
						if (this.preparoId) {
							axios
								.post(
									`${this.$store.state.serverURI
								}/api/cadastros/preparos/update/${this.preparoId}`,
									this.dados,
									this.$store.getters.getHeaderAuth
								)
								.then(response => {
									this.$swal({
										type: "success",
										title: "Preparo atualizado com sucesso!",
										showConfirmButton: false,
										timer: 1500
									});
									this.$router.push("/cadastros/preparos/");
								})
								.catch(error => {
									var erros = error.response.data.message + " ";
									for (var erro of Object.values(error.response.data.errors)) {
										erros += erro + " \n";
									}
									this.$swal({
										type: "error",
										title: "Houve uma falha!",
										text: erros
									});
								});
						} else {
							axios
								.post(
									`${this.$store.state.serverURI}/api/cadastros/preparos/create`,
									this.dados,
									this.$store.getters.getHeaderAuth
								)
								.then(response => {
									this.$swal({
										type: "success",
										title: "Preparo criado com sucesso!",
										showConfirmButton: false,
										timer: 1500
									});
									this.$router.push("/cadastros/preparos");
								})
								.catch(error => {
									var erros = error.response.data.message + " ";
									for (var erro of Object.values(error.response.data.errors)) {
										erros += erro + " \n";
									}
									this.$swal({
										type: "error",
										title: "Houve uma falha!",
										text: erros
									});
								});
						}

					}
				});
			}
		},
		watch: {},
		components: {}
	};
</script>

<style>

</style>



// WEBPACK FOOTER //
// form.vue?016942ae